<core-helpers-forms-key-select-multiple
    [label]="label"
    [options]="items"
    [scrollTop]="scrollTopValue"
    (selectValue)="onSelect($event)"
    (selectScrollTop)="onScrollTop($event)"
></core-helpers-forms-key-select-multiple>